import React, { useState, useEffect } from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  HashRouter,
} from "react-router-dom";
import PublicLayout from "../layouts/PublicLayout";
import MainView from "../views/MainView";

const AppRouter = () => {
  

  /*
  const checkDevice = () => {
    const userAgent = navigator.userAgent.toLowerCase();
    const mobileKeywords =
      /android|webos|iphone|ipod|blackberry|iemobile|opera mini/i;
    const tabletKeywords = /ipad|tablet|playbook|silk|(android(?!.*mobile))/i;

    const isMobileDevice = mobileKeywords.test(userAgent);
    const isTabletUA = tabletKeywords.test(userAgent);

    const isMobileWidth = window.innerWidth <= 768;
    const isTabletWidth = window.innerWidth >= 768 && window.innerWidth <= 1024;

    const isTouchDevice =
      "ontouchstart" in window || navigator.maxTouchPoints > 0;

    const isTablet = (isTabletUA || isTabletWidth) && isTouchDevice;

    const criteriaCount = [isMobileDevice, isMobileWidth, isTouchDevice].filter(
      Boolean
    ).length;

    setIsMobile(criteriaCount >= 2);
    setIsTablet(isTablet); // <-- agrega este estado
  };

  useEffect(() => {
    checkDevice();
  }, [])
  */

  //nueva opcion: detecta si es movil o tabler - incluso en simuladores
  const [deviceType, setDeviceType] = useState("desktop");

  const [isMobile, setIsMobile] = useState(false);
  const [isTablet, setIsTablet] = useState(false);

  useEffect(() => {
    const detectDevice = () => {
      const width = window.innerWidth;
      const height = window.innerHeight;
      const aspect = height / width;
      const ua = navigator.userAgent.toLowerCase();

      const isTouch =
        "ontouchstart" in window || navigator.maxTouchPoints > 0;

      // --- 1) DETECCIÓN REAL (iPad, Galaxy Tab) ---

      // iPadOS moderno (iPad Pro se identifica como Mac)
      const isModernIpad =
        navigator.platform === "MacIntel" &&
        navigator.maxTouchPoints > 1;

      // Android tablet real (UA: "Android" sin "Mobile")
      const isAndroidTablet =
        /android/.test(ua) && !/mobile/.test(ua);

      // Real mobile devices
      const isRealMobile =
        /iphone|android.+mobile/i.test(ua) && isTouch;

      const isRealTablet =
        (isModernIpad || isAndroidTablet) && isTouch;


      // --- 2) DETECCIÓN POR VIEWPORT (Simuladores / DevTools) ---

      const isViewportMobile = width < 768;

      // Tablets típicas: 768px - 1280px con aspecto tablet
      const isViewportTablet =
        width >= 768 &&
        width <= 1280 &&
        aspect > 1.0 &&
        aspect < 1.8;


      // --- 3) DECISIÓN FINAL ---

      if (isRealMobile || isViewportMobile) {
        setDeviceType("mobile");
        return;
      }

      if (isRealTablet || isViewportTablet) {
        setDeviceType("tablet");
        return;
      }

      setDeviceType("desktop");
    };

    detectDevice();
    window.addEventListener("resize", detectDevice);
    return () => window.removeEventListener("resize", detectDevice);
  }, []);

  useEffect(() => {
    setIsTablet(false);
    setIsMobile(false);

    if(deviceType == "tablet")
      setIsTablet(true)

   if(deviceType == "mobile")
      setIsMobile(true)

  }, [deviceType])

  return (
    <HashRouter>
      <Routes>
        <Route element={<PublicLayout isMobile={isMobile} isTablet={isTablet} />}>
          <Route path="/" element={<MainView isMobile={isMobile} />} />
        </Route>
      </Routes>
    </HashRouter>
  );
};

export default AppRouter;
